<template>
  <div class="read-more-column">
    <h2>{{ heading }}</h2>
    <div class="video-container">
      <iframe
        :src="source"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;"
        allowfullscreen
      ></iframe>
    </div>

    <FunkButton button-text="Read More" @buttonClicked="drawerOpen()" />
  </div>
</template>

<script>
  export default {
    name: 'AdditionalInfoComponent',
    methods: {
      drawerOpen() {
        this.$emit('drawerOpen');
      },
    },
    props: {
      heading: {
        type: String,
        required: false,
        default: null,
      },
      source: {
        type: String,
        required: false,
        default: null,
      },
    },
    components: {},
    data() {
      return {};
    },
    mounted() {},
  };
</script>

<style lang="scss" scoped>
  .read-more-column {
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    padding: 30px 0;
    h2 {
      font-size: 22px;
      font-weight: 600;
      line-height: 23.4px;
      color: var(--v-primary-base);
    }

    .video-container {
      position: relative;
      padding-bottom: 56.25%;
      height: 0;
      overflow: hidden;
      max-width: 100%;
      margin: 26px 0;
      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
  .read-more-column.isMobile {
    margin-top: 40px;
    margin-bottom: 40px;
  }
</style>
